import Highlight, { defaultProps, Language } from "prism-react-renderer";
import React, { forwardRef } from "react";
import prismTheme from "../../utils/prismTheme";
import classNames from "classnames";

interface CodeProps {
  className?: string;
  code: string;
  language: Language;
}

const Code = forwardRef<HTMLElement, CodeProps>(({ className, code, language }, ref) => {
  return (
    <code className={classNames("kld-code", className)} ref={ref}>
      <Highlight {...defaultProps} code={code} language={language} theme={prismTheme}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={className} style={style}>
            {tokens.map((line, i) => (
              <div {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </code>
  );
});

export default Code;
